export default "__VITE_ASSET__BXflrbTV__"